import { render, staticRenderFns } from "./SelectorEmpresa.vue?vue&type=template&id=55ad0fb2&scoped=true&"
import script from "./SelectorEmpresa.vue?vue&type=script&lang=js&"
export * from "./SelectorEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./SelectorEmpresa.vue?vue&type=style&index=0&id=55ad0fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad0fb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
